import Vue from "vue";
import Router from "vue-router";
import loginController from './views/login.vue'

import store from "./store"

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'loginController',
    component: loginController,
    meta: {
      title: 'login'
    }
  },
  {
    path: "/main",
    name: "homeController",
    component: () =>
      import("./views/Home.vue"),
    children: [
      {
        path: "homePage",
        component: () => import("./views/homePage.vue"),
        meta: {
          title: 'home',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' }
          ]
        },
      },
      {
        path: "userList",
        component: () => import("./views/userList.vue"),
        meta: {
          title: 'userList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User Listing' }
          ]
        },
      },
      {
        path: "userDetail",
        component: () => import("./views/userDetail.vue"),
        meta: {
          title: 'userDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User Listing' },
            { to: '/main/userDetail', text: 'userDetail' }
          ]
        },
      },
      {
        path: "roleList",
        component: () => import("./views/roleList.vue"),
        meta: {
          title: 'roleList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role listing' }
          ]
        },
      },
      {
        path: "roleDetail",
        component: () => import("./views/roleDetail.vue"),
        meta: {
          title: 'roleDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role listing' },
            { to: '/main/roleDetail', text: 'roleDetail' }
          ]
        },
      },
      {
        path: "articleList",
        component: () => import("./views/articleList.vue"),
        meta: {
          title: 'articleList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/articleList', text: 'articleList' }
          ]
        },
      },
      {
        path: "articleDetail",
        component: () => import("./views/articleDetail.vue"),
        meta: {
          title: 'articleDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/articleList', text: 'articleList' },
            { to: '/main/articleDetail', text: 'articleDetail' }
          ]
        },
      },
      // {
      //   path: "editorDemo",
      //   component: () => import("./views/editorDemo.vue"),
      //   meta: {
      //     title: 'editorDemo',
      //     breadcrumbs: [
      //         { to: '/main/homePage', text: 'HomePage' },
      //         { to: '/main/editorDemo', text: 'editorDemo' }
      //     ]
      //   },
      // },
      {
        path: "subCategoryList",
        component: () => import("./views/subCategoryList.vue"),
        meta: {
          title: 'subCategoryList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/subCategoryList', text: 'subCategoryList' }
          ]
        },
      },
      {
        path: "subCategoryDetail",
        component: () => import("./views/subCategoryDetail.vue"),
        meta: {
          title: 'subCategoryDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/subCategoryList', text: 'subCategoryList' },
            { to: '/main/subCategoryDetail', text: 'subCategoryDetail' }
          ]
        },
      },
      {
        path: "issueList",
        component: () => import("./views/issueList.vue"),
        meta: {
          title: 'issueList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/issueList', text: 'issueList' }
          ]
        },
      },
      {
        path: "issueDetail",
        component: () => import("./views/issueDetail.vue"),
        meta: {
          title: 'issueDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/issueList', text: 'issueList' },
            { to: '/main/issueDetail', text: 'issueDetail' }
          ]
        },
      },
      {
        path: "resourceList",
        component: () => import("./views/resourceList.vue"),
        meta: {
          title: 'resourceList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/resourceList', text: 'resourceList' }
          ]
        },
      },
      {
        path: "resourceDetail",
        component: () => import("./views/resourceDetail.vue"),
        meta: {
          title: 'resourceDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/resourceList', text: 'resourceList' },
            { to: '/main/resourceDetail', text: 'resourceDetail' }
          ]
        },
      },
      {
        path: "resourceCategoryList",
        component: () => import("./views/resourceCategoryList.vue"),
        meta: {
          title: 'resourceCategoryList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/resourceCategoryList', text: 'resourceCategoryList' },
          ]
        },
      },
      {
        path: "resourceCategoryDetail",
        component: () => import("./views/resourceCategoryDetail.vue"),
        meta: {
          title: 'resourceCategoryDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/resourceCategoryList', text: 'resourceCategoryList' },
            { to: '/main/resourceCategoryDetail', text: 'resourceCategoryDetail' }
          ]
        },
      },
      {
        path: "courseImport",
        component: () => import("./views/courseImport.vue"),
        meta: {
          title: 'courseImport',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/courseImport', text: 'courseImport' },
          ]
        },
      },
      {
        path: "areaOfStudyImport",
        component: () => import("./views/areaOfStudyImport.vue"),
        meta: {
          title: 'areaOfStudyImport',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/areaOfStudyImport', text: 'areaOfStudyImport' },
          ]
        },
      },
      {
        path: "floatingBanner",
        component: () => import("./views/floatingBanner.vue"),
        meta: {
          title: 'floatingBanner',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/floatingBanner', text: 'floatingBannerList' },
          ]
        },
      },
      {
        path: "floatingBannerDetail",
        component: () => import("./views/floatingBannerDetail.vue"),
        meta: {
          title: 'floatingBannerDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/floatingBanner', text: 'floatingBannerList' },
            { to: '/main/floatingBannerDetail', text: 'floatingBannerDetail' },
          ]
        },
      },
      {
        path: "departmentBanner",
        component: () => import("./views/departmentBanner.vue"),
        meta: {
          title: 'departmentBanner',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/departmentBanner', text: 'departmentBannerList' },
          ]
        },
      },
      {
        path: "departmentBannerDetail",
        component: () => import("./views/departmentBannerDetail.vue"),
        meta: {
          title: 'departmentBannerDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/departmentBanner', text: 'departmentBannerList' },
            { to: '/main/departmentBannerDetail', text: 'departmentBannerDetail' },
          ]
        },
      },
      {
        path: "topBanner",
        component: () => import("./views/topBanner.vue"),
        meta: {
          title: 'topBanner',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/topBanner', text: 'topBannerList' },
          ]
        },
      },
      {
        path: "topBannerDetail",
        component: () => import("./views/topBannerDetail.vue"),
        meta: {
          title: 'topBannerDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/topBanner', text: 'topBannerList' },
            { to: '/main/topBannerDetail', text: 'topBannerDetail' },
          ]
        },
      },
      {
        path: "ShortTermJob",
        component: () => import("./views/shortTermJob.vue"),
        meta: {
          title: 'jobImportList',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/shortTermJob', text: 'jobImportList' },
          ]
        },
      },
      {
        path: "jobImportDetail",
        component: () => import("./views/shortTermJobDetail.vue"),
        meta: {
          title: 'jobImportDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/shortTermJob', text: 'jobImportList' },
            { to: '/main/jobImportDetail', text: 'jobImportDetail' },
          ]
        },
      },
      {
        path: "infoCentre",
        component: () => import("./views/infoCentreImport.vue"),
        meta: {
          title: 'Info Centre management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/infoCentre', text: 'Info Centre management' },
          ]
        },
      },
      {
        path: "occupationImport",
        component: () => import("./views/occupationImport.vue"),
        meta: {
          title: 'Occupation management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/occupation', text: 'Occupation management' },
          ]
        },
      },
      {
        path: "tagImport",
        component: () => import("./views/tagImport.vue"),
        meta: {
          title: 'Import Tag',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagImport', text: 'Import Tag' },
          ]
        },
      },
      {
        path: "resource",
        component: () => import("./views/resourceImport.vue"),
        meta: {
          title: 'Resource management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/resource', text: 'Resource management' },
          ]
        },
      },
      {
        path: "quiz",
        component: () => import("./views/quiz.vue"),
        meta: {
          title: 'Quiz management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/quiz', text: 'Quiz management' },
          ]
        },
      },

      {
        path: "qrCourseImport",
        component: () => import("./views/qrCourseImport.vue"),
        meta: {
          title: 'Import QR course',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/qrCourseImport', text: 'Import QR course' },
          ]
        },
      },
      {
        path: "cefCourseImport",
        component: () => import("./views/cefCourseImport.vue"),
        meta: {
          title: 'Import CEF course',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/cefCourseImport', text: 'Import CEF course' },
          ]
        },
      },
      {
        path: "cipVtcMapImport",
        component: () => import("./views/cipVtcMapImport.vue"),
        meta: {
          title: 'Import VTC CIP',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/cipVtcMapImport', text: 'Import VTC CIP' },
          ]
        },
      },
      {
        path: "areaOfStudyMapImport",
        component: () => import("./views/areaOfStudyMapImport.vue"),
        meta: {
          title: 'Import Area of Study',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/areaOfStudyMapImport', text: 'Import Area of Study' },
          ]
        },
      },
      {
        path: "deliveryModeMapImport",
        component: () => import("./views/deliveryModeMapImport.vue"),
        meta: {
          title: 'Import Delivery mode',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/deliveryModeMapImport', text: 'Import Delivery mode' },
          ]
        },
      },
      {
        path: "levelMapImport",
        component: () => import("./views/levelMapImport.vue"),
        meta: {
          title: 'Import Level',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/levelMapImport', text: 'Import Level' },
          ]
        },
      },
      {
        path: "systemTheme",
        component: () => import("./views/systemTheme.vue"),
        meta: {
          title: 'System Theme management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/systemTheme', text: 'System Theme management' },
          ]
        },
      },
      {
        path: "eightCentresList",
        component: () => import("./views/eightCentresList.vue"),
        meta: {
          title: 'Eight Centres Management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eightCentresList', text: 'Eight Centres Management' }
          ]
        },
      },
      {
        path: "eightCentresContent",
        component: () => import("./views/eightCentresContent.vue"),
        meta: {
          title: 'Centres Content',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eightCentresContent', text: 'Centres Content' },
          ]
        },
      },
      {
        path: "eightCentresContentDetail",
        component: () => import("./views/eightCentresContentDetail.vue"),
        meta: {
          title: 'Centres Content',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eightCentresContent', text: 'Centres Content' },
            { to: '/main/eightCentresContentDetail', text: 'Add Centres Content' },
          ]
        },
      },
    ]
  },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    store.commit("setPageTitle", to.meta.title)
    document.title = `MIP-cms | ${store.state.pageTitle}`
  }
  next()
})

export default router
